import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: StrictMode disabled to prevent double-render issues with auth
// This was causing alternating login failures in Chrome
root.render(
  <App />
);
